<template>
    <div class="page-container">
        <div class="page-inner page-left">
            <div class="page-box-title title1">作文指导</div>
            <div>
                <el-row :gutter="10" style="margin-top:10px;">
                    <el-col :span="24">
                        <el-input maxlength="5000" v-model="guideText" type="textarea" :rows="6" placeholder="请输入作文题目和要求"></el-input>
                    </el-col>
                </el-row>
                <div class="correct-tip">
                    <span class="activeColor">*提示：</span>
                    <span>文本和图片形式的作文题目二选一即可</span>
                </div>
                <el-row :gutter="10" style="margin-top:10px;">
                    <el-col :span="24">
                        <el-upload class="upload-box" v-model:file-list="fileList" action="#" list-type="picture-card" :http-request="httpRequest" :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
                            <div class="upload-inner">
                                <div>
                                    <el-icon size="24">
                                        <Camera />
                                    </el-icon>
                                </div>
                                <div>作文上传</div>
                            </div>
                        </el-upload>
                    </el-col>
                </el-row>
            </div>
            <div style="margin:20px 0;">
                <el-button :disabled="aiStart" style="width:100%" color="#ef8b25" class="footer-btn1" @click="guideClick">三步九法作文指导</el-button>
            </div>
        </div>
        <div class="page-inner page-right">
            <div class="page-box-title2 title1">三步九法作文指导</div>
            <div class="page-inner-box" v-if="Object.keys(resultInfo).length">
                <div class="" v-if="resultInfo.Ⅱ && resultInfo.Ⅱ.length">
                    <div class="correctTitle">
                        作文题目解析：
                    </div>
                    <div class="" v-for="(item,index) in resultInfo.Ⅱ" :key="index">
                        <div v-html="item"></div>
                    </div>
                </div>
                <div class="" v-if="resultInfo.Ⅲ && resultInfo.Ⅲ.length">
                    <div class="correctTitle">
                        作文题目指导：
                    </div>
                </div>
                <div class="">
                    <template v-if="resultInfo.Ⅲ && resultInfo.Ⅲ.length">
                        <div class="correctTitle2">【放】</div>
                        <div class="" v-for="(item,index) in resultInfo.Ⅲ" :key="'f'+index">
                            <div class="correctTitle3" v-if="index==0">多头放想</div>
                            <div class="correctTitle3" v-if="index==4">多向放想</div>
                            <div class="correctTitle3" v-if="index==8">多见放想</div>
                            <div v-html="item"></div>
                        </div>
                    </template>
                    <template v-if="resultInfo.Ⅳ && resultInfo.Ⅳ.length">
                        <div class="correctTitle2">【悟】</div>
                        <div class="" v-for="(item,index) in resultInfo.Ⅳ" :key="'w'+index">
                            <div class="correctTitle3" v-if="index==0">触发悟道</div>
                            <div class="correctTitle3" v-if="index==3">推导悟道</div>
                            <div class="correctTitle3" v-if="index==8">升维悟道</div>
                            <div class="correctTitle3" v-if="index==12">守正悟道</div>
                            <div v-html="item"></div>
                        </div>
                    </template>
                    <template v-if="resultInfo.Ⅴ && resultInfo.Ⅴ.length">
                        <div class="correctTitle2">【收】</div>
                        <div class="" v-for="(item,index) in resultInfo.Ⅴ" :key="'s'+index">
                            <div class="correctTitle3" v-if="index==0">打包</div>
                            <div class="correctTitle3" v-if="index==2">整合</div>
                            <div v-html="item"></div>
                        </div>
                    </template>
                </div>
                <div class="" v-if="resultInfo.Ⅶ && resultInfo.Ⅶ.length">
                    <div class="correctTitle">
                        总结：
                    </div>
                </div>
                <div v-if="resultInfo.Ⅶ && resultInfo.Ⅶ.length">
                    <div class="" v-for="(item,index) in resultInfo.Ⅶ" :key="'z'+index">
                        <div v-html="item"></div>
                    </div>
                </div>
            </div>
            <div v-html="aiMessage" class="page-inner-box" v-if="!Object.keys(resultInfo).length && aiMessage && aiMessage!='{}'"></div>
            <div class="page-inner-box empty" v-if="!Object.keys(resultInfo).length && !aiMessage">
                <img src="@/assets/img/empty.png" />
                <div>结果将在此处展示！</div>
            </div>
        </div>

        <el-image-viewer v-if="showPreview" :url-list="previewFileArr" show-progress :initial-index="previewIndex" @close="showPreview = false" />
        <AIpopup v-if="popupShow" :cancelShow="false" :popupShow="popupShow" @cancel="aiCancel"></AIpopup>
    </div>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';
import { compGuidanceStreaming, saveSreamResult, checkAiCall } from "@/api/composition.js"
import { uploadImg, delImgApi } from "@/api/common.js"
import { useRoute } from 'vue-router';
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import AIpopup from "./components/AIpopup.vue";
const route = useRoute()
import { useStore } from "vuex"
const store = useStore();
const guideText = ref('')

const fileList = ref([])
const showPreview = ref(false)
const previewIndex = ref(0)
const previewFileArr = ref([])
let fileArr = []
const aiStart = ref(false)
const popupShow = ref(false)

let controller = null
let aiMessage = ref('')
let resultInfo = ref({})
const romanNumerals = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ"];
let resultNum = {}, currentKey = '', regex = new RegExp(`(${romanNumerals.join('|')})|([^${romanNumerals.join('')}]+)`, 'g');
function aiCancel() {
    aiStart.value = false;
    popupShow.value = false;
    controller && controller.abort()
}
function guideClick() {
    if (!guideText.value && !fileList.value.length) {
        return ElMessage.warning('请填写作文文本或拍摄作文');
    }
    checkAiCall().then(res => {
        if (res.data.result) {
            ElMessageBox.confirm(
                `今日AI调用频繁，已超过${res.data.num}次`,
                '温馨提示',
                {
                    confirmButtonText: '继续用',
                    type: 'warning',
                    showCancelButton: false
                }
            ).then(() => {
                getAi()
            })
        } else {
            getAi()
        }
    })

}
function getAi() {
    const params = {
        grade: sessionStorage.getItem("grade"),
        term: sessionStorage.getItem("term"),
        text: guideText.value || '',
        fileIds: fileArr.map(item => {
            return item.fileId
        }).join(','),
    }
    aiStart.value = true
    popupShow.value = true;
    compGuidanceStreaming(params).then(res => {
        fetchRequest(res.data)
    }).catch(() => {
        aiStart.value = false
        popupShow.value = false;
    })
}

async function fetchRequest(params) {
    controller = new AbortController()
    aiMessage.value = ''
    resultInfo.value = {}
    resultNum = {}
    currentKey = ''
    const { signal } = controller;
    const response = await fetch('https://api.coze.cn/v1/workflow/stream_run', {
        signal,
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + params.token,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params.aiParam)
    })
    popupShow.value = false;
    if (!response.ok) {
        try {
            const errorData = await response.join()
            aiStart.value = false
            return ElMessage.warning(errorData.message || '请求失败')
        } catch (error) {
            console.log(error)
            aiStart.value = false
            return ElMessage.warning('请求失败')
        }
    }

    const reader = response.body.getReader()
    const decoder = new TextDecoder('utf-8')
    let done = false;
    let obj = {}
    let str = ''
    while (!done) {
        const {
						done: readerDone,
            value
					} = await reader.read()
        done = readerDone;

        if (value) {
            const chunkText = decoder.decode(value, {
                stream: !done
            })
            const lines = chunkText.split('\n')
            let isMessage = true;
            lines.forEach(line => {
                if (line.startsWith('event: Done')) {
                    isMessage = false;
                    aiStart.value = false
                    saveSreamResult({ ...params.returnParam, text: aiMessage.value }).then(res => {
                        console.log(res)
                    })
                }
                if (line.startsWith('event: Error')) {
                    isMessage = false;
                    aiStart.value = false;
                    return ElMessage.warning('AI调用失败，请稍后再试！');
                }
                if (isMessage && line.startsWith('data:')) {
                    const jsonString = line.substring(5).trim();
                    try {
                        const jsonData = JSON.parse(jsonString)
                        const content = (jsonData ?.content || '');
                        if (content) {
                            str += content
                            const matches = content.match(regex) || [];
                            let resultArr = matches.filter(match => match !== '');
                            resultArr.forEach(info => {
                                if (romanNumerals.includes(info)) {
                                    if (info in resultNum) {
                                        resultNum[info] = resultNum[info] + 1;
                                        resultInfo.value[info].push('');
                                    } else {
                                        resultNum[info] = 1;
                                        resultInfo.value[info] = [''];
                                    }
                                    currentKey = info;
                                } else if (currentKey in resultInfo.value) {
                                    if (resultNum[currentKey] == 1) {
                                        resultInfo.value[currentKey][resultNum[
                                            currentKey] - 1] += info.replace(/^\s+/, "").replace(/\n+/g, '<br/>');
                                    } else {
                                        resultInfo.value[currentKey][resultNum[
                                            currentKey] - 1] += info.replace(/\n+/g, '<br/>');
                                    }

                                }
                            })
                            console.log(resultInfo.value)
                            aiMessage.value = str
                        }
                    } catch (error) {
                        console.log(error)
                        aiStart.value = false
                    }
                }
            })
        } else {
            aiStart.value = false;
        }
    }
}

function httpRequest(params) {
    const fileInfo = new FormData()
    fileInfo.append('file', params.file)
    const loading = ElLoading.service({
        lock: true,
        background: 'rgba(0, 0, 0, 0.5)',
    })
    uploadImg(fileInfo).then(res => {
        fileArr.push(res.data)
        previewFileArr.value.push(res.data.fileUrl)
        fileList.value[fileList.value.length - 1]['fileId'] = res.data.fileId;
    }).finally(() => {
        loading.close()
    })
}

function handlePictureCardPreview(file) {
    previewIndex.value = fileArr.findIndex(item => {
        return item.fileId == file.fileId
    })
    showPreview.value = true;
}

function handleRemove(file) {
    if (file.fileId) {
        const index = fileArr.findIndex(item => {
            return item.fileId == file.fileId
        })
        // delImgApi(file.fileId).then(res => {
        ElMessage.success('删除成功')
        fileArr.splice(index, 1)
        previewFileArr.value.splice(index, 1)
        // })
    }
}
onBeforeUnmount(() => {
    controller && controller.abort()
})
</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.correct-title {
    font-size: 12px;
    color: $base-text-color;
    line-height: 1.8;
    margin: 20px 0;
}

.correct-tip {
    font-size: 12px;
    margin: 10px 0;
    color: #999;
}

.upload-box {
     ::v-deep .el-upload-list--picture-card {
        --el-upload-list-picture-card-size: 120px;
    }
     ::v-deep .el-upload--picture-card {
        --el-upload-picture-card-size: 120px
    }
    .upload-inner {
        text-align: center;
        color: #ccc;
    }
}
</style>
